import { connect } from 'react-redux';
import Authenticate from './Authenticate';
import { getAuthenticationConfiguration } from '../../store/selectors/site.selectors';
import { userAuthenticated } from '../../store/actions/authentication.actions';

const mapStateToProps = (state: any) => ({
    config: getAuthenticationConfiguration(state),
});

const mapDispatchToProps = {
    userAuthenticated,
};

export default connect(mapStateToProps, mapDispatchToProps)(Authenticate);
